import { useState, useEffect } from "react";
const responsiveArray = ["xxl", "xl", "lg", "md", "sm", "xs"];
function useMergePropByScreen(defaultProp, oriProp, screen) {
  const [prop, setProp] = useState(typeof oriProp === "string" ? oriProp : defaultProp);
  const calcMergeAlignOrJustify = () => {
    if (typeof oriProp === "string") {
      setProp(oriProp);
    }
    if (typeof oriProp !== "object") {
      return;
    }
    for (let i = 0; i < responsiveArray.length; i++) {
      const breakpoint = responsiveArray[i];
      if (!screen[breakpoint]) {
        continue;
      }
      const curVal = oriProp[breakpoint];
      if (curVal !== void 0) {
        setProp(curVal);
        return;
      }
    }
  };
  useEffect(() => {
    calcMergeAlignOrJustify();
  }, [JSON.stringify(oriProp), screen]);
  return prop;
}
export {
  useMergePropByScreen as default,
  responsiveArray
};
//# sourceMappingURL=useMergePropByScreen.js.map
